import s from '../index.module.scss';

export const CustomDot = ({
  cx,
  cy,
  index,
  dataKey,
  hovered,
  setHovered,
  containerRef,
}) => {
  const isActive = hovered?.index === index && hovered?.key === dataKey;

  const handleMouseEnter = () => {
    if (!containerRef.current) return;
    const containerRect = containerRef.current.getBoundingClientRect();
    setHovered({
      index,
      key: dataKey,
      x: cx + containerRect.left,
      y: cy + containerRect.top,
    });
  };

  const strokeColor = dataKey === 'earnings' ? '#a07d2c' : '#f7931a';

  return (
    <circle
      cx={cx}
      cy={cy}
      r={isActive ? 4 : 3}
      fill={isActive ? strokeColor : '#fff'}
      stroke={strokeColor}
      strokeWidth={2}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setHovered(null)}
      className={s.circle}
      style={{ cursor: 'pointer' }}
    />
  );
};
